"use client";

/**
 * EmpleadoSuccess.jsx
 * Página que muestra un mensaje de éxito después de guardar un legajo de empleado,
 * junto con un resumen de los datos ingresados.
 * @date 23-10-2025
 * @param {Object} DataEmpleado - Objeto con los datos del empleado guardado.
 *
 */
import { useEffect, useState } from "react";
import {
  Container,
  Paper,
  Typography,
  Box,
  Button,
  Grid,
  Divider,
  Alert,
} from "@mui/material";
import {
  CheckCircle as CheckCircleIcon,
  ArrowBack as ArrowBackIcon,
} from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";

export default function CreatedSuccessPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const { DataEmpleado } = location.state || {};
  const { datosPersonales, datosLaborales,telefonosEmpleado,familiares   } = DataEmpleado;
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleDateString();
  };
  // Función para manejar el botón de vuelta
  const handleGoBack = () => {
    // 💥 Navegación a la ruta del formulario 💥
    navigate("/RRHH2/legajos");
  };

  if (!location.state) {
    // Si alguien intenta acceder directamente a /empleados/exito sin datos
    return (
      <div>
        <h1>Acceso Denegado</h1>
        <p>No se encontraron datos de transacción.</p>
        <button onClick={handleGoBack}>Ir al Formulario</button>
      </div>
    );
  }
  return (
    <Container maxWidth="md">
      <Box sx={{ py: 4 }}>
        <Paper elevation={3} sx={{ p: 3 }}>
          <Box sx={{ textAlign: "center", mb: 2 }}>
            <CheckCircleIcon
              sx={{ fontSize: 60, color: "success.main", mb: 1 }}
            />
            <Typography
              variant="h5"
              component="h1"
              gutterBottom
              fontWeight="bold"
            >
              ¡Legajo Guardado Exitosamente!
            </Typography>
            <Typography variant="body2" color="text.secondary">
              El empleado <b>{datosPersonales.nombre} {datosPersonales.apellido}</b> ha sido registrado.
            </Typography>
          </Box>

          <Divider sx={{ my: 2 }} />

          <Grid container spacing={2}>
            {/* Información Personal */}
            <Grid item xs={12}>
              <Typography variant="subtitle2" color="primary" sx={{ mb: 1, fontWeight: "bold" }}>
                Información Personal
              </Typography>
            </Grid>
            
            {[
              { label: "CUIL", value: datosPersonales.cuil },
              { label: "Documento", value: datosPersonales.nro_doc },
              { label: "Legajo", value: datosPersonales.nro_legajo },
              { label: "Email", value: datosPersonales.email },
              { label: "Fecha Ingreso", value: formatDate(datosPersonales.fecha_ingreso) },
           
            ].map((item, idx) => (
              <Grid item xs={6} sm={4} key={idx}>
                <Box>
                  <Typography variant="caption" color="text.secondary" display="block">
                    {item.label}
                  </Typography>
                  <Typography variant="body2" fontWeight="medium">
                    {item.value}
                  </Typography>
                </Box>
              </Grid>
            ))}

            <Grid item xs={12} sx={{ mt: 1 }}>
              <Divider />
            </Grid>

            {/* Información Laboral */}
           {/*  <Grid item xs={12}>
              <Typography variant="subtitle2" color="primary" sx={{ mb: 1, fontWeight: "bold" }}>
                Información Laboral
              </Typography>
            </Grid>
            
            {[
              { label: "Sucursal ID", value: datosLaborales.sucursal_id },
              { label: "Puesto ID", value: datosLaborales.puesto_id },
              { label: "Sector ID", value: datosLaborales.sector_id },
              { label: "Categoría ID", value: datosLaborales.categoria_id || "N/A" },
              { label: "Tarea ID", value: datosLaborales.tarea_id || "N/A" },
              { label: "Obra Social ID", value: datosLaborales.obra_social_id || "N/A" },
            ].map((item, idx) => (
              <Grid item xs={6} sm={4} key={idx}>
                <Box>
                  <Typography variant="caption" color="text.secondary" display="block">
                    {item.label}
                  </Typography>
                  <Typography variant="body2" fontWeight="medium">
                    {item.value}
                  </Typography>
                </Box>
              </Grid>
            ))} */}
{/* 
            <Grid item xs={12} sx={{ mt: 1 }}>
              <Divider />
            </Grid>
 */}
            {/* Otros */}
            <Grid item xs={6} sm={4}>
              <Box>
                <Typography variant="caption" color="text.secondary" display="block">
                  Teléfonos
                </Typography>
                <Typography variant="body2" fontWeight="medium">
                  {telefonosEmpleado?.length || 0} registrados
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={6} sm={4}>
              <Box>
                <Typography variant="caption" color="text.secondary" display="block">
                  Familiares
                </Typography>
                <Typography variant="body2" fontWeight="medium">
                  {familiares?.length || 0} registrados
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={6} sm={4}>
              <Box>
                <Typography variant="caption" color="text.secondary" display="block">
                  Estado
                </Typography>
                <Typography variant="body2" fontWeight="medium" color="success.main">
                  Activo
                </Typography>
              </Box>
            </Grid>
          </Grid>

          <Box sx={{ mt: 3, display: "flex", gap: 2 }}>
            <Button
              variant="contained"
              fullWidth
              size="large"
              onClick={handleGoBack}
              startIcon={<ArrowBackIcon />}
              sx={{ borderRadius: 2 }}
            >
              Registrar Nuevo Empleado
            </Button>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
}
